<template>
  <v-dialog v-model="dialogValue" max-width="500px" lazy>
    <v-card>
      <alert-banner :msg="alertMessage" />
      <v-form @submit.prevent="saveAddCourse">
        <v-card-title>
          <span class="headline">
            Add New Course
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap row justify-center>
              <v-flex xs11>
                <v-text-field v-model="addForm.title" v-validate="'required'" name="title" label="Course Title*" required :error-messages="errors.collect('title')" />
              </v-flex>
              <v-flex xs11>
                <v-autocomplete v-model="addForm.userId"
                                v-validate="'required'"
                                :items="authors"
                                label="Select an Author"
                                name="author"
                                cache-items
                                hide-no-data
                                hide-selected
                                item-value="id"
                                item-text="fullName"
                                placeholder="Start typing to Search"
                                :search-input.sync="search"
                                :error-messages="errors.collect('author')"
                                :loading="loadingAutocomplete"
                >
                  <template v-slot:selection="data">
                    {{ data.item.fullName }} ({{ data.item.email }})
                  </template>
                  <template v-slot:item="data">
                    <v-list-tile-avatar>
                      <img :src="data.item.profileImageUrl">
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.fullName" />
                      <v-list-tile-sub-title v-html="data.item.email" />
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <span class="pl-4">
            <small>*indicates required field</small>
          </span>
          <v-spacer />
          <v-btn flat @click="dialogValue = false">
            Close
          </v-btn>
          <v-btn type="submit" color="secondary darken-1" flat :loading="saving">
            Add Course
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios';
  import _ from 'lodash';

  export default {
    props: {
      dialog: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      loadingAutocomplete: false,
      search: null,
      defaultAddForm: {
        title: '',
        userId: '',
      },
      addForm: {
        title: '',
        userId: '',
      },
      authors: [],
      saving: false,
    }),

    computed: {
      dialogValue: {
        get() {
          return this.dialog;
        },
        set(value) {
          this.$emit('update:dialog', value);
        },
      },
    },

    watch: {
      dialogValue(val) {
        if (!val) {
          setTimeout(() => {
              Object.keys(this.addForm).filter(key => key in this.defaultAddForm).forEach(key => this.addForm[key] = this.defaultAddForm[key]); // eslint-disable-line
            this.clearErrors();
          }, 300);
        } else {
          this.$validator.pause();
        }
      },

      search(val) {
        this.loadingAutocomplete = true;
        this.processSearch();
      },
    },

    methods: {
      async getUsers() {
        const { data } = await axios.get(`/api/users/dropdown?filter=${this.search}&currentPage=0&pageSize=20`);
        this.authors = data.resultItems;
      },

      async saveAddCourse() {
        const result = await this.startFormProcessing();
        if (!result) return;
        this.saving = true;
        try {
          const { data } = await axios.post('/api/courses', this.addForm);
          window.location.href = `/AuthorDashboard/ManageCourse/${data.id}`;
        } catch (error) {
          this.processErrors(error, this.addForm);
          this.saving = false;
        }
      },

      processSearch: _.debounce(function (e) {
        this.getUsers().then(() => {
          this.loadingAutocomplete = false;
        });
      }, 600),
    },
  };
  </script>